module.exports = __webpack_public_path__ + "static/media/high-voltage.6c04b6a1.png";